/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import API from '../../requests';
import FireboardUtils from '../../util/fireboard-util';
import { getPopupConfig } from '../../components/Popup';
import constants from '../../globalization';
import View from './views';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import withCubbyContext from '../../context-api/CubbyContext/withCubbyContext';
import CommonUtil from '../Fireboard/common';
import { getPickerData } from "../../components/CountryPicker";
import UTILLib from "../../util";
import EventEmitter from '../../util/event-emitter';
import { LogLevelEnum, checkEnum } from '../../enums';
import { retryPOSPayment } from "../../store/actions";
import { TimeConstants } from '../../constants';
import MenuUtils from '../../util/menu-utils';
import { version } from '../../../package.json';

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

const POPUPS_ENUMS = {
  SMS: "sms",
  GENERATE_QR: "generate-qr",
  MEMBER_DETAILS: "member-details",
  GENERATE_QR_JOIN_CHECK: "generate-qr-join-check",
  CHECK_ACTIONS: "check-actions",
  RE_POST_PAYMENT: "repostpayment",
  VIEW_ON_MAP: "viewOnMap",
  REDEEM_CHECK_VOUCHER: "redeemCheckVoucher",
  UPDATE_GUEST_INFO: "updateGuestInformation",
};

class StoreCubby extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      isCustomSmsType: true,
      customSmsList: [],
      selectedCountry: {},
      selectedCheck: {},
      twoDimensionSlot: [[]],
      sensorData: {},
      isDevEnvironment: false,
      fromFooter: false,
      checksForAssignment: new Map(),
      isPickedUpUndoEnabled: false,
      sortByName: false,
      ascending: true,
      showCheckDetails: false,
      items: [],
      pendingItems: [],
      showClosedChecks: true,
      showSearch: false,
      searchedValue: '',
    };
    this.checks = new Map();
    this.currency = this.props?.reduxProps?.currencyInfo?.currency || '$';
    this.countriesData = [];
    this.parentRoute = '';
    this.storeCubbySlotsMap = new Map();
    this.occupiedSlot = null;
    this.notifyOrderPrepared = {};
    this.notifyOrderReady = {};
    this.filteredChecks = [];
    this.activeCheckFilter = 'sourceType';
    this.checkSourceTypes = [];
    this.checkOrderTypes = [];
    this.checkRevenueTypes = [];
    this.checkSensorGroupTypes = [];
    this.seatId = null;
    this.sensorsMap = new Map();
    this.enableAgeRestrictedOrderingForCheck = false;
    this.enableAgeRestrictedOrderingForSeat = false;
    this.enableAgeVerification = false;
    this.ageRestrictedItemsForSeat = {};
  }

  componentDidMount() {
    const { reduxProps, history } = this.props;
    const { storeInfo, deviceInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting Store Cubby component with storeId ${storeId} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 15 }
      });
      return;
    }

    this.getCustomSmsTemplates();

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      this.state.isDevEnvironment = true;
    }

    const { location } = history || {};
    const { state } = location || {};
    const { parentRoute } = state || {};
    this.parentRoute = parentRoute;

    this.countriesData = getPickerData();
    const countryCode = this.currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    this.state.selectedCountry = this.countriesData.find(country => country.iso2 === countryCode);

    this.buildSensorsHashTable();
    this.setDeviceGroupData();

    const { context, cubbyContext } = this.props;
    this.setChecks(context?.checks);
    this.state.isPickedUpUndoEnabled = cubbyContext?.isPickedUpUndoEnabled || false;

    if (window.ReactNativeWebView) {
      this.scanToRedeemListener = message => this.onVoucherScanned(message);
      EventEmitter.addListeners('onVoucherScanned', this.scanToRedeemListener);
    }

    this.startInterval();
  }

  componentWillUnmount() {
    if (window.ReactNativeWebView) {
      this.scanToRedeemListener && EventEmitter.removeListeners('onVoucherScanned', this.scanToRedeemListener);
    }

    this.stopInterval();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { reduxProps } = newProps;
    this.handleRetryPOSPayment(reduxProps);

    if (this.props?.context !== newProps?.context) {
      const { context: nextContext } = newProps;
      this.setChecks(nextContext?.checks, nextContext?.deletedChecks);
    }

    if (this.props.cubbyContext !== newProps.cubbyContext) {
      const { isPickedUpUndoEnabled } = newProps.cubbyContext;
      this.setState({ isPickedUpUndoEnabled: isPickedUpUndoEnabled });
    }
  }

  setChecks = (checks, deletedChecks) => {
    let checksMap = new Map();
    const allChecks = Array.from(checks.values());
    allChecks && allChecks.forEach(check => {
      checksMap.set(check.id, CommonUtil.parseCheckFromRedis(check));
    });
    this.checks = checksMap;
    this.refreshCubby();
  };

  setDeviceGroupData = () => {
    const { reduxProps: { deviceApi, deviceApiData, storeInfo } } = this.props;
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
      const {
        fireBoardSettings,
        checkChannelFilters,
        checkOrderTypeFilters,
        checkRevenueCenterFilters,
        checkSensorGroupFilters,
      } = deviceGroup || {};
      this.activeCheckFilter = CommonUtil.getActiveFilterSourceFromDeviceGroup(fireBoardSettings);
      this.checkSourceTypes = CommonUtil.getODOrderTypes(checkChannelFilters);
      this.checkOrderTypes = CommonUtil.getPOSOrderTypes(checkOrderTypeFilters, storeInfo?.data?.orderTypes);
      this.checkRevenueTypes = CommonUtil.getRevenueCenterOrderTypes(checkRevenueCenterFilters, storeInfo?.data?.revenueCenters);
      this.checkSensorGroupTypes = CommonUtil.getSensorGroupOrderTypes(checkSensorGroupFilters, storeInfo?.data?.sensorGroups);
      this.enableAgeRestrictedOrderingForCheck = fireBoardSettings?.enableAgeRestrictedOrderingForCheck || false;
      this.enableAgeRestrictedOrderingForSeat = fireBoardSettings?.enableAgeRestrictedOrderingForSeat || false;
      this.enableAgeVerification = fireBoardSettings?.enableAgeVerification || false;
    } else {
      const { reduxProps } = this.props;
      const { storeTypesPersist } = reduxProps;
      const { activeCheckFilter, sourceTypes, orderTypes, revenueTypes, sensorGrpTypes } = storeTypesPersist?.data || {};
      this.activeCheckFilter = activeCheckFilter || 'sourceType';
      this.checkSourceTypes = sourceTypes || [];
      this.checkOrderTypes = orderTypes || [];
      this.checkRevenueTypes = revenueTypes || [];
      this.checkSensorGroupTypes = sensorGrpTypes || [];
    }
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  showPopup = (type, data) => {
    switch (type) {
      case POPUPS_ENUMS.CHECK_ACTIONS:
        const check = data?.checkData || {};
        this.setState({ popup: { type }, selectedCheck: check });
        break;
      case 'cubbyLayout':
      case POPUPS_ENUMS.SMS:
      case POPUPS_ENUMS.RE_POST_PAYMENT:
      case POPUPS_ENUMS.REDEEM_CHECK_VOUCHER:
      case POPUPS_ENUMS.VIEW_ON_MAP:
      case POPUPS_ENUMS.UPDATE_GUEST_INFO:
        this.setState({ popup: { type } });
        break;
      default:
        console.warn('case not handled!!!');
        break;
    }
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  goBack = () => {
    const { history } = this.props;
    history && history.goBack();
  };

  getFilteredChecks = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const checks = Array.from(this.checks.values());
    const filters = {
      data: {
        orderTypes: this.checkOrderTypes,
        sourceTypes: this.checkSourceTypes,
        revenueTypes: this.checkRevenueTypes,
        sensorGroupTypes: this.checkSensorGroupTypes,
        activeCheckFilter: this.activeCheckFilter,
      }
    };
    const allChecks = CommonUtil.getAllSelectedChecks(checks, filters, storeInfo, this.sensorsMap);
    //should not display voided checks
    const filteredCheckList = allChecks.filter(check => {
      const { orders } = check;
      const [order0] = orders || [];
      if (check?.void === true || orders?.length === 0 || order0?.orderStatusId === 10)
        return false;
      return true;
    });

    return filteredCheckList;
  };

  refreshCubby = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { storeCubby } = storeInfo?.data || {};
    this.storeCubbySlotsMap = FireboardUtils.buildStoreCubbyHashTable(storeCubby);
    this.filteredChecks = this.getFilteredChecks();
    const checks = this.getFormattedChecks;
    const twoDimensionSlot = FireboardUtils.getCubbySlotsData(storeCubby, checks);
    this.setState({ twoDimensionSlot });
  };

  get getFormattedChecks() {
    const { reduxProps: { currencyInfo } } = this.props;
    const { iso2 } = currencyInfo || {};

    const formattedChecks = this.filteredChecks.map(check => {
      const [order0] = check?.orders || [];
      const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
      const slotName = slot?.name || '';
      const { slotBorderColor, slotElapsedTimeInMS } = this.getSlotElapsedTime(check);
      const pickupTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(order0?.pickupDate);
      const { locationElapsedTimeInMinTxt, locationRefButtonColor } = this.getLocationElapsedTime(order0?.lastLocationUpdateDate);
      return {
        selectedCheckDetails: check,
        checkNumber: check.checkNumber,
        number: check.number,
        id: check.id,
        checkHeaderId: check.checkHeaderId,
        deliverTo: FireboardUtils.getDeliverTo(check),
        sourceType: check.sourceType,
        phoneNumber: check.phoneNumber ? FireboardUtils.formattedPhoneNumber(check.phoneNumber, iso2) : "- -",
        unFormattedPhoneNumber: check.phoneNumber,
        orderStatusId: check.orderStatusId,
        pickupDate: order0.pickupDate,
        pickupTimeInMS: pickupTimeInMS,
        orderDate: check.orderDate,
        openDate: check.openDate,
        orders: check.orders,
        orderTypeId: check.orderTypeId,
        checkName: check.name,
        checkInNote: check.checkInNote,
        unpaidAmount: check.unpaidAmount,
        open: check.open,
        slotName: slotName,
        stationId: check.stationId,
        referenceId: check.referenceId,
        taxAmount: check.taxAmount,
        subTotalAmount: check.subTotalAmount,
        totalAmount: check.totalAmount,
        guestName: check.guestName,
        items: check.items,
        tickets: check.tickets,
        seats: check.seats,
        stationName: check.stationName,
        employeeFirstName: check.employeeFirstName,
        employeeLastName: check.employeeLastName,
        slotBorderColor: slotBorderColor,
        slotElapsedTimeInMS: slotElapsedTimeInMS,
        locationUpdateElapsedTime: locationElapsedTimeInMinTxt,
        locationRefreshButtonColor: locationRefButtonColor,
      };
    });
    return formattedChecks || [];
  };

  getSlotElapsedTime = (check) => {
    const { reduxProps: { deviceApi, deviceApiData } } = this.props;
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    const { orders } = check || {};
    const [order0] = orders || [];
    const { slotAssignmentDate, pickupDate, orderDate } = order0 || {};
    const elapsedTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(slotAssignmentDate || pickupDate || orderDate);
    let slotBorderColor = 'white';

    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
      const { orderUpWarningTime, orderUpErrorTime, orderUpClearTime } = deviceGroup || {}; //time is in seconds
      let orderUpWarningTimeInMS = 0;
      let orderUpErrorTimeInMS = 0;
      let orderUpClearTimeInMS = 0;

      if (orderUpWarningTime)
        orderUpWarningTimeInMS = orderUpWarningTime * TimeConstants.SECOND;
      if (orderUpErrorTime)
        orderUpErrorTimeInMS = orderUpErrorTime * TimeConstants.SECOND;
      if (orderUpClearTime)
        orderUpClearTimeInMS = orderUpClearTime * TimeConstants.SECOND;

      if (
        orderUpWarningTimeInMS &&
        orderUpErrorTimeInMS &&
        elapsedTimeInMS > orderUpWarningTimeInMS &&
        elapsedTimeInMS < orderUpErrorTimeInMS
      ) {
        slotBorderColor = 'orange';
      } else if (
        orderUpErrorTimeInMS &&
        orderUpClearTimeInMS &&
        elapsedTimeInMS > orderUpErrorTimeInMS &&
        elapsedTimeInMS < orderUpClearTimeInMS
      ) {
        slotBorderColor = 'red';
      }
    }

    return { slotBorderColor, slotElapsedTimeInMS: elapsedTimeInMS };
  };

  startInterval = () => {
    this.stopInterval();
    this.interval = setInterval(() => {
      this.refreshCubby();
    }, TimeConstants.MINUTE);
  };

  stopInterval = () => {
    this.interval && clearInterval(this.interval);
    this.interval = null;
  };

  getLocationElapsedTime = (refTime) => {
    const locationElapsedTimeInMS = FireboardUtils.getElapsedTimeInMilliseconds(refTime);
    const locationElapsedTimeInMin = locationElapsedTimeInMS / TimeConstants.MINUTE;
    const locationElapsedTimeInMinTxt = FireboardUtils.convertElapsedTimeToDisplayTime(locationElapsedTimeInMS);
    let locationRefButtonColor = 'red';
    if (locationElapsedTimeInMin <= 3)
      locationRefButtonColor = 'green';
    else if (locationElapsedTimeInMin > 3 && locationElapsedTimeInMin <= 6)
      locationRefButtonColor = 'orange';
    else if (locationElapsedTimeInMin > 6)
      locationRefButtonColor = 'red';
    return { locationElapsedTimeInMinTxt, locationRefButtonColor };
  };

  onChangeSmsType = () => {
    this.setState(prevState => ({
      isCustomSmsType: !prevState.isCustomSmsType,
    }));
  };

  getCustomSmsTemplates = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    API.getCustomSmsTemplates(storeId)
      .then(response => {
        let { isCustomSmsType, customSmsList } = this.state;
        isCustomSmsType = (response.data && response.data.length > 0) ? true : false;
        customSmsList = response.data || [];
        if (customSmsList && customSmsList.length > 0) {
          this.notifyOrderPrepared = customSmsList.find(each => each.smsTemplate?.smsType === 110) || {};
          this.notifyOrderReady = customSmsList.find(each => each.smsTemplate?.smsType === 112) || {};
        }
        this.setState({ isCustomSmsType, customSmsList });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onHandleSend = (msg, customSmsObj) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, currencyInfo: { iso2 } } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck, selectedCountry, isCustomSmsType } = this.state;
    const popup = getPopupConfig("error");
    popup.heading = constants.confirmationMessage;
    const phoneNumberForSMS = FireboardUtils.formattedPhoneNumber(selectedCheck?.phoneNumber || '', iso2);
    popup.message = constants.sendSmsPopupMsg;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => {
          this.getPopup('spinner', constants.smdSendLoaderHeading, null);
          const { latitude, longitude } = UTILLib.location;
          let payload = {
            latitude,
            longitude,
            deviceId: deviceId,
            storeId: storeInfo?.data?.id,
            phoneNumber: selectedCheck?.unFormattedPhoneNumber || null,
            countryCode: selectedCountry.dialCode.split('+')[1],
            message: msg,
            checkHeaderId: selectedCheck?.checkHeaderId || selectedCheck?.id,
          };
          if (isCustomSmsType) {
            payload = {
              ...payload,
              custom: true,
              templateId: customSmsObj?.id,
            };
          }
          if (this.seatId) {
            payload['seatId'] = this.seatId;
            this.seatId = null;
          }
          API.fireboardSendSMS(payload)
            .then((resp) => {
              this.closePopup();
              FireboardUtils.addNetworkLogs(resp);
            })
            .catch((error) => this.handleErrorPopup(error));
        },
      },
    ];
    this.setState({ popup });
  };

  onSlotActionButtonPress = (type, slot) => {
    this.occupiedSlot = slot;
    this.state.selectedCheck = slot?.checkData || {};
    switch (type) {
      case 'notify':
        this.showPopup('sms');
        break;
      case 'move':
        this.showPopup('cubbyLayout');
        break;
      case 'clear':
        this.clearSlot();
        break;
      case 'pickedUp':
        this.pickedUp();
        break;
      default:
        console.warn('case not handled!!!');
        break;
    }
  };

  onSlotAssign = slot => {
    const { checksForAssignment } = this.state;
    if (checksForAssignment && checksForAssignment.size === 0) {
      this.getPopup("error", null, 'Select check to assign to this cubby slot');
      return;
    }
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const checkHeaderIds = [...checksForAssignment.keys()];
    const checkHeaderId = checkHeaderIds[0];
    const { id: storeCubbySlotId, name: slotName } = slot || {};
    const payload = {
      storeId,
      checkHeaderId,
      storeCubbySlotId
    };
    this.state.checksForAssignment = new Map();
    this.callCubbyAssignApi(payload, 'Assigning slot', `Slot ${slotName} is assigned`);
  };

  clearSlot = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const { name: slotName } = this.occupiedSlot || {};

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        storeCubbySlotId: null
      };
      this.callCubbyAssignApi(payload, 'Clearing slot', `Slot ${slotName} is cleared`);
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = `This will clear the order from slot ${slotName}. Do you want to continue?`;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  onMoveSlotOrder = (selectedSlots) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const slotIds = [...selectedSlots.keys()];
    const slotId = slotIds[0];
    const slots = [...selectedSlots.values()];
    const [slot0] = slots || []
    const slotName = slot0?.name || '';
    const payload = {
      storeId,
      checkHeaderId,
      storeCubbySlotId: slotId
    };
    this.callCubbyAssignApi(payload, 'Moving order', `Order is moved to slot ${slotName}`);
  };

  callCubbyAssignApi = (payload, spinnerMsg, toastMsg) => {
    this.getPopup('spinner', spinnerMsg);
    API.cubbyAssign(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        toast.success(toastMsg, { autoClose: 1000 });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  pickedUp = () => {
    const { reduxProps: { storeInfo }, cubbyContext } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};

    //when an order is marked as picked up, enable the undo icon and store the order details
    const { setUndoOrderInfo } = cubbyContext || {};
    setUndoOrderInfo && setUndoOrderInfo({ ...this.occupiedSlot });

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        counter: false,
      };
      this.getPopup('spinner', 'Marking order as picked up');
      API.orderPickedUp(payload)
        .then(response => {
          this.state.popup = undefined;
          const updatedCheck = response.data;
          this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
          this.refreshCubby();
          toast.success('Marked order as picked up', { autoClose: 1000 });
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    callback && callback();
  };

  updateOrderStatus = (item, type) => {
    let delivery = false;
    let deliveryVendorName = '';
    let held = false;
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
      held = item.orders[0].held || false;
    }
    let orderStatusId;
    if (type === "done") {
      // TODO: add enums
      orderStatusId = 5;
      this.dispatchOrderStatus(item, orderStatusId);
    } else if (type === "cancel") {
      const popup = getPopupConfig("success");
      popup.heading = constants.orderCancellation;
      popup.message = held
        ? delivery
          ? 'This action will cancel the order immediately. The order delivery will also be canceled at ' + deliveryVendorName + '. If applicable, the order will not be sent to the POS. This action cannot be reversed. Do you want to continue?'
          : constants.cancelHeldOrderMsg
        : delivery
          ? 'Are you sure you want to cancel the order ? This action will ONLY cancel from the Fireboard and ' + deliveryVendorName + '. This action will NOT cancel from the POS and NOT process a refund.'
          : constants.cancelCheckHeadingAlt;
      popup.buttons = [
        {
          text: constants.no,
          onClick: () => {
            this.setState({ popup: undefined });
          },
        },
        {
          text: constants.yes,
          onClick: () => {
            this.cancelOrder(item);
          },
        },
      ];
      this.setState({ popup });
    } else if (type === "moveToInprogress") {
      const popup = getPopupConfig("error");
      popup.heading = constants.futureToIPHeader;
      popup.message = held ? constants.moveHeldOrderMsg : constants.futureToIPMessage;
      popup.buttons = [
        {
          text: constants.noCaps,
          onClick: () => this.setState({ popup: undefined }),
        },
        {
          text: constants.yesCaps,
          onClick: () => {
            orderStatusId = 1;
            this.dispatchOrderStatus(item, orderStatusId);
          },
        },
      ];
      this.setState({ popup });
    }
  };

  cancelOrder = (item) => {
    const orderStatusId = 8;
    this.dispatchOrderStatus(item, orderStatusId, true);
  };

  dispatchOrderStatus = (item, orderStatusId, isCancel) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    let delivery = false;
    let deliveryVendorName = '';
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
    }
    API.orderStatusUpdate({
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      checkHeaderId: item?.id,
      orderStatusId,
    })
      .then((response) => {
        console.debug("response from orderStatusUpdate", response);
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        if (isCancel) {
          const popup = getPopupConfig("success", () => {
            this.closePopup();
          });
          popup.heading = constants.cancelSuccess;
          popup.message = delivery
            ? 'Order has been cancelled from the Fireboard and ' + deliveryVendorName + '. Please make sure to cancel it on the POS and process a refund from the portal (if applicable)'
            : constants.cancelSuccessMsg;
          this.setState({ popup });
        } else {
          this.closePopup();
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  markItemAsPaid = item => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    API.orderStatusPaid({
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      checkHeaderId: item?.id,
    })
      .then((response) => {
        console.debug("response from orderStatusPaid", response);
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.setState({ popup: undefined });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  notifyOrderStatus = (type) => {
    const { selectedCheck, selectedCountry } = this.state;
    const { checkHeaderId, id, phoneNumber } = selectedCheck;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { id: storeId } = storeInfo?.data || {};
    this.getPopup("spinner", type === 'orderBeingPrepared' ? constants.notifyOrderBeingPrepared : constants.notifyOrderReady, null);
    let templateId = type === 'orderBeingPrepared' ? this.notifyOrderPrepared?.id : this.notifyOrderReady?.id;
    const { latitude, longitude } = UTILLib.location;
    let payload = {
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeId,
      phoneNumber: phoneNumber || "",
      countryCode: selectedCountry.dialCode.split('+')[1],
      custom: true,
      templateId: templateId,
      checkHeaderId: checkHeaderId || id,
    };
    API.fireboardSendSMS(payload)
      .then((resp) => {
        this.closePopup();
        FireboardUtils.addNetworkLogs(resp);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  joinCheck = item => {
    const { sensorData } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    const { stationId } = item || {};
    this.getPopup('spinner', 'Generating QR', null);
    if (sensorData && sensorData.externalId) {
      this.setState({
        popup: {
          type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
          meta: item,
          sensorData: sensorData,
        },
      });
    } else {
      API.sensorCode({
        storeId: storeId,
        stationId: stationId,
      })
        .then((resp) => {
          this.setState({
            sensorData: resp.data,
            popup: {
              type: POPUPS_ENUMS.GENERATE_QR_JOIN_CHECK,
              meta: item,
              sensorData: resp.data,
            },
          });
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => this.handleErrorPopup(error));
    }
  };

  onResyncCheck = item => {
    this.getPopup('spinner', constants.syncingCheck, null);
    API.syncCheck({
      checkHeaderId: item.checkHeaderId,
    })
      .then(response => {
        const checkData = CommonUtil.parseCheckFromRedis(response.data);
        this.checks.set(response.data.id, checkData);
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  invokeTextToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const {
      phoneNumber,
      guestName,
      pickupTime,
      checkNumber,
      subTotal,
      tax,
      selectedCountry,
      preAuth,
    } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck } = this.state;
    const { checkHeaderId } = selectedCheck || {};
    this.getPopup("spinner", constants.textToPayGenLoader, null);
    API.generateTextToPay({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo?.data?.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +subTotal,
      taxAmount: +tax,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId,
      preAuth: preAuth || false,
    })
      .then((response) => {
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: () => this.closePopup(),
          },
          {
            text: constants.retry,
            onClick: () => this.invokeTextToPay(payload),
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  invokeCheckIn = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { phoneNumber, guestName, pickupTime, checkNumber, selectedCountry, } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck } = this.state;
    const { checkHeaderId } = selectedCheck || {};
    this.getPopup("spinner", constants.checkInRequestLoader, null);
    API.checkInRequest({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo?.data?.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +0,
      taxAmount: +0,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId,
    })
      .then((response) => {
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: () => this.closePopup(),
          },
          {
            text: constants.retry,
            onClick: () => this.invokeCheckIn(payload),
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  rePostPayment = ticket => {
    const { reduxProps, dispatchRetryPOS } = this.props;
    const { storeInfo, deviceApi } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const payload = {
      employeeId: null,
      storeId,
      deviceId,
      employeeCard: null,
      ticketId: ticket?.ticketId,
      checkTicketId: ticket?.id,
    };
    dispatchRetryPOS && dispatchRetryPOS(payload);
  };

  handleRetryPOSPayment = reduxProps => {
    const { reduxProps: prevReduxProps } = this.props;
    if (reduxProps.retryPOSPayment.timestamp !== prevReduxProps.retryPOSPayment.timestamp) {
      if (reduxProps.retryPOSPayment.data) {
        const popup = getPopupConfig('success');
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.error) {
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = reduxProps.retryPOSPayment.error;
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = 'Posting Payment';
        this.setState({ popup });
      }
    }
  };

  onRedeemVoucher = (type, data) => {
    if (type === 'scanToRedeem' && window.ReactNativeWebView) {
      EventEmitter.scanQRCodeToRedeem('scanToRedeem');
    } else if (type === 'redeemCode') {
      const { first, last } = data || {};
      this.showRedeemConfirmation({
        voucherCodeTextFirst4: first,
        voucherCodeTextLast4: last,
      });
    } else if (type === 'managerOverride') {
      const { employeeCode } = data || {};
      this.showRedeemConfirmation({
        employeeCode: employeeCode,
      });
    }
  };

  onVoucherScanned = qrCode => {
    this.showRedeemConfirmation({
      voucherQrCode: qrCode,
    });
  };

  showRedeemConfirmation = payload => {
    const callback = () => {
      const { selectedCheck } = this.state;
      const { id: checkHeaderId } = selectedCheck || {};
      const { reduxProps: { storeInfo, deviceApi } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const { deviceId } = deviceApi?.data;
      const newPayload = {
        ...payload,
        storeId,
        deviceId,
        checkHeaderId,
      };
      this.getPopup('spinner', 'Applying Voucher', null);
      API.voucherCheckIn(newPayload)
        .then(response => {
          const newCheck = response.data;
          this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
          this.closePopup();
          FireboardUtils.addNetworkLogs(response);
        })
        .catch((error) => this.handleErrorPopup(error));
    };

    const oldPopup = this.state.popup;
    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will redeem the voucher and send any items to the kitchen. This action cannot be undone. Do you want to continue?';
    popup.buttons = [
      {
        text: 'No',
        onClick: () => this.setState({ popup: oldPopup })
      },
      {
        text: 'Yes',
        onClick: () => {
          callback && callback();
        },
      }
    ];
    this.setState({ popup });
  };

  generateQR = item => {
    this.setState({
      popup: {
        type: POPUPS_ENUMS.GENERATE_QR,
        meta: item,
      },
    });
  };

  onHandleTextToPay = (item, fromFooter) => {
    this.setState({ popup: { type: "textToPay", meta: item }, fromFooter });
  };

  textToCheckIn = (item, fromFooter) => {
    this.setState({ popup: { type: "checkIn", meta: item }, fromFooter });
  };

  openPaymentHistory = () => this.showPopup('repostpayment');

  onPressRedeemVoucher = () => this.showPopup('redeemCheckVoucher');

  onRequestRefreshGuestGPS = () => {
    const oldPopup = this.state.popup;

    const callback = () => {
      this.getPopup('spinner', 'Sending SMS to request guest location');
      const { checkHeaderId } = this.state?.selectedCheck || {};
      API.textToGetLocation(checkHeaderId)
        .then(response => {
          this.setState({ popup: oldPopup })
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will send a text message to the guest requesting their location. Do you want to continue?';
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.setState({ popup: oldPopup }),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  onSelectCheckForAssignment = check => {
    const checkMap = new Map();
    checkMap.set(check.checkHeaderId, check);
    this.setState({ checksForAssignment: checkMap });
  };

  onOrderDelivered = check => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = check || {};
    const payload = {
      storeId,
      checkHeaderId
    };
    this.getPopup('spinner', "Marking order as delivered");
    API.gpsLocationPickedUp(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateGuestInformation = guestInfo => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId } = selectedCheck || {};
    const payload = {
      storeId,
      checkHeaderId,
      ...guestInfo,
    };
    this.getPopup('spinner', "Updating guest information");
    API.updateGuestInformation(payload)
      .then(response => {
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsSeeCounter = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const payload = {
      storeId,
      checkHeaderId,
      counter: true,
    };
    this.getPopup('spinner', 'Marking order as picked up');
    API.orderPickedUp(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  undoPickedUp = () => {
    const { cubbyContext } = this.props;
    const { undoOrderInfo, setUndoOrderInfo } = cubbyContext;
    const { rowNumber, columnNumber } = undoOrderInfo || {};

    //get currently occupied slot information from 2-dimensional array of slots
    const { twoDimensionSlot } = this.state;
    const currentlyOccupiedSlot = twoDimensionSlot[rowNumber - 1][columnNumber - 1];

    //if slot information has "checkData" (non empty object) then slot is already occupied else not
    if (FireboardUtils.isObjectBlank(currentlyOccupiedSlot?.checkData)) {
      //if slot is not assigned - call assign slot endpoint with undo order details
      const { reduxProps: { storeInfo } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const { checkData, id: storeCubbySlotId, name: slotName } = undoOrderInfo || {};
      const { id: checkHeaderId } = checkData || {};
      const payload = {
        storeId,
        checkHeaderId,
        storeCubbySlotId
      };
      setUndoOrderInfo && setUndoOrderInfo({}); //reset undo order details
      this.callCubbyAssignApi(payload, 'Assigning slot', `The order has been moved to cubby #${slotName}`);
    } else {
      //if slot is already occupied then show error msg
      const { checkNumber, totalAmount } = currentlyOccupiedSlot?.checkData || {};
      const errorMsg = `Cannot undo because the slot is occupied.\n\nOrder details:\n#${checkNumber}\n${this.currency}${totalAmount}`;
      this.getPopup('error', 'Error', errorMsg);
    }
  };

  onToggleSwitch = name => {
    if (name === 'sortByName') {
      this.setState(prevState => ({ sortByName: !prevState.sortByName }));
    } else if (name === 'ascending') {
      this.setState(prevState => ({ ascending: !prevState.ascending }));
    } else if (name === 'showClosedChecks') {
      this.setState(prevState => ({ showClosedChecks: !prevState.showClosedChecks }));
    }
  };

  sortChecksByTime = (a, b) => {
    const time1 = a.pickupTimeInMS;
    const time2 = b.pickupTimeInMS;
    return time1 - time2;
  };

  sortChecksByName = (a, b) => {
    const deliverTo1 = FireboardUtils.pad(a.deliverTo ? a.deliverTo : '').toLowerCase();
    const deliverTo2 = FireboardUtils.pad(b.deliverTo ? b.deliverTo : '').toLowerCase();
    if (deliverTo1 < deliverTo2)
      return -1;
    if (deliverTo1 > deliverTo2)
      return 1;
    return 0;
  };

  getCheckSortFunc = () => {
    const { sortByName } = this.state;
    const sortFunc = sortByName ? this.sortChecksByName : this.sortChecksByTime;
    return sortFunc;
  };

  onShowCheckDetails = check => {
    let items = check && check.items;
    let pendingItems = [];
    const isPOSOrder = CommonUtil.getOrderTypeFromSourceType(check.sourceType) === constants.orderType_POS;
    if (isPOSOrder) {
      items = FireboardUtils.updatePOSItems(check);
      const pendingCheckItems = MenuUtils.getPendingItemsFromCheck(check);
      pendingItems = FireboardUtils.updatePendingPOSItems(pendingCheckItems, check);
    }
    this.setState(prevState => ({
      showCheckDetails: !prevState.showCheckDetails,
      selectedCheck: check,
      items,
      pendingItems,
    }));
  };

  onCloseCheckDetails = () => {
    this.setState({ showCheckDetails: false });
  };

  showMemberDetailPopup = (memberId) => {
    this.getPopup("spinner", "Getting member details", null);
    API.getMemberDetails({ memberId })
      .then((res) => {
        this.setState({
          popup: {
            type: POPUPS_ENUMS.MEMBER_DETAILS,
            metaData: res.data,
          },
        });
        FireboardUtils.addNetworkLogs(res);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  onClickSms = seatId => {
    this.seatId = seatId;
    this.setState({ popup: { type: POPUPS_ENUMS.SMS } });
  };

  onPrintPress = (type, printMeta) => {
    const { selectedCheck } = this.state;
    const { reduxProps: { storeInfo, deviceApi } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const { id, checkHeaderId } = selectedCheck || {};
    let requestBody;
    let requestType;
    let printType;
    let spinnerMsg;
    if (type === 'check') {
      if (printMeta.display === 'GUEST RECEIPT') {
        if (selectedCheck && Object.keys(selectedCheck).length !== 0) {
          this.printCheck(selectedCheck);
          printType = 'Guest Receipt';
        }
        return;
      } else if (printMeta.display === 'FULL ORDER LABEL') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId: checkHeaderId || id,
          includeItems: false,
        };
        requestType = 'printCheck';
        printType = 'Full Order Label';
      } else if (printMeta.display === 'ORDER + ITEMS LABELS') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId: checkHeaderId || id,
          includeItems: true,
        };
        requestType = 'printCheck';
        printType = 'Order + Items';
      } else if (printMeta.display === 'INDIVIDUAL ITEM LABELS') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId: checkHeaderId || id,
          checkItemIds: selectedCheck && selectedCheck.items.map(i => i.checkItemId),
        };
        requestType = 'printCheck';
        printType = 'Item Labels'
      } else if (printMeta.display === 'KITCHEN TICKET') {
        requestBody = {
          storeId,
          deviceId,
          checkHeaderId,
        };
        requestType = 'printOrderTicket';
        printType = 'Kitchen Ticket';
      }
      spinnerMsg = `Printing ${printMeta.display}`;
    } else if (type === 'item') {
      requestBody = {
        storeId,
        deviceId,
        checkHeaderId: checkHeaderId || id,
        checkItemIds: [printMeta.checkItemId],
      };
      requestType = 'printItems';
      printType = 'Items';
      spinnerMsg = 'Printing item';
    }
    this.printCheckItems(type, printMeta, printType, requestType, requestBody, spinnerMsg);
  };

  printCheckItems = (type, printMeta, printType, requestType, requestBody, spinnerMsg) => {
    const { selectedCheck, items } = this.state;
    const { id: checkId, number: checkNumber, sourceType } = selectedCheck || {};
    this.getPopup('spinner', spinnerMsg, null);
    API[requestType](requestBody)
      .then(response => {
        FireboardUtils.addNetworkLogs(response);
        console.info('response from print', response);
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = response.data.printerName
          ? `${constants.printLoading} at ${response.data.printerName}`
          : constants.printLoading;
        let updatedItems = [];
        const isPOSOrder =
          CommonUtil.getOrderTypeFromSourceType(sourceType) ===
          constants.orderType_POS;
        if (isPOSOrder) {
          if (type === 'item') {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => {
                  if (eachItem.id === printMeta.checkItemId) {
                    return {
                      ...eachItem,
                      printed: true,
                    };
                  }
                  return eachItem;
                });
              });
          } else {
            Object.keys(items) &&
              Object.keys(items).forEach(eachKey => {
                updatedItems[eachKey] = items[eachKey].map(eachItem => ({
                  ...eachItem,
                  printed: true,
                }));
              });
          }
        } else if (type === 'item') {
          updatedItems = items.map(eachItem => {
            if (eachItem.id === printMeta.checkItemId) {
              return {
                ...eachItem,
                printed: true,
              };
            }
            return eachItem;
          });
        } else {
          updatedItems = items.map(eachItem => ({
            ...eachItem,
            printed: true,
          }));
        }
        this.setState({ popup: printPopup, items: updatedItems });
        if (printType === 'Kitchen Ticket') {
          const { printJobs } = response.data;
          const printDataArray = Array.isArray(printJobs) ? printJobs : [];
          printDataArray.forEach(data =>
            this.printReceipt({
              type: 'print',
              data,
              printType,
            }, checkId, checkNumber)
          );
        } else {
          var data = {
            type: "print",
            data: response.data,
            printType,
          };
          this.printReceipt(data, checkId, checkNumber);
        }
        setTimeout(() => {
          this.closePopup();
        }, 4000);
      })
      .catch(error => {
        console.debug('error', error, error.response);
        this.handleErrorPopup(error);
      });
  };

  printReceipt = (data, checkId, checkNumber) => {
    const { printerIpAddress, printerName, printerPort } = data?.data || {};
    const logData = {
      checkId,
      checkNumber,
      printerName,
      printerIpAddress,
      printType: data?.printType,
    };
    UTILLib.printReceipt(
      data,
      () => this.closePopup(),
      error => {
        console.warn('error while printing receipt', error);
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = "Trying to connect to " + printerName + " with IP Address " + printerIpAddress + " and port " + printerPort + " " + error;
        this.setState({ popup });
        this.addPrintLog({ ...logData, status: 'FAILURE' });
      },
      () => {
        let popup = getPopupConfig('error', () => this.closePopup());
        popup.message = constants.extensionNotAvailable;
        this.setState({ popup });
        this.addPrintLog({ ...logData, status: 'SUCCESS' });
      },
    );
  };

  addPrintLog = logData => {
    const { checkId, checkNumber, printerName, printerIpAddress, status, printType } = logData || {};
    EventEmitter.addLogs(
      'appLogs',
      LogLevelEnum.INFO,
      `Print - ${moment(new Date).format('YYYY-MM-DD hh:mm:ss')} | Check Id - ${checkId} | Check Number - ${checkNumber} | Print Type - ${printType} | Printer Name - ${printerName} | Printer IP Address - ${printerIpAddress} | Print Status - ${status}`
    );
  };

  printCheck = (item) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, employee } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const { loginId } = employee || {}
    const { id } = item;
    const payload = {
      storeId,
      deviceId,
      employeeId: 0,
      checkHeaderId: id,
      seatIds: [],
      employeeCard: loginId || null,
    };
    this.getPopup('spinner', constants.printLoading, null);
    API.tableReceiptPrint(payload)
      .then(response => {
        const printPopup = getPopupConfig('spinner');
        printPopup.heading = `${constants.printWithStation} ${response.data.printerName}`;
        this.setState({ popup: printPopup });
        var data = {
          type: "print",
          data: response.data,
        };
        const errorMsg = "Trying to connect to " + response.data.printerName + " with IP Address " + response.data.printerIpAddress + " and port " + response.data.printerPort + " ";
        UTILLib.printReceipt(
          data,
          () => this.closePopup(),
          error => this.getPopup('error', null, errorMsg + error),
          () => {
            let popup = getPopupConfig('error', () => this.closePopup());
            popup.message = constants.extensionNotAvailable;
            this.setState({ popup });
          },
        );
        setTimeout(() => {
          this.closePopup();
        }, 4000);
      })
      .catch(error => {
        this.handleErrorPopup(error);
      });
  };

  onToggleSearchInput = (showSearch) => {
    this.setState({ showSearch, searchedValue: '' });
  };

  onSearch = searchedValue => {
    this.setState({ searchedValue });
  };

  getCheckList = () => {
    const formattedCheck = this.getFormattedChecks;
    const { searchedValue, showSearch, showClosedChecks } = this.state;
    const value = searchedValue.toLowerCase();
    let checks = [...formattedCheck];
    if (showClosedChecks) {
      checks = checks.filter(check => {
        //should not display checks if all items are flagged as counter
        const { items } = check;
        let counterFlag = true;
        if (items && Array.isArray(items) && items.length > 0) {
          counterFlag = items.some(item => item?.serviceMode !== 1);
        }

        //show only checks where check.open = false
        let openFlag = check?.open === false;

        return (counterFlag && openFlag);
      });
    }

    if (showSearch && searchedValue) {
      checks = checks.filter(check => {
        const { checkNumber, deliverTo } = check || {}
        if ((checkNumber && checkNumber.toLowerCase().includes(value)) ||
          (deliverTo && deliverTo.toLowerCase().includes(value))) {
          return true;
        }
        return false;
      });
    }
    return checks || [];
  };

  buildSensorsHashTable = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensors } = storeInfo?.data || {};
    this.sensorsMap = FireboardUtils.buildSensorsHashTable(sensors);
  };

  openCaptureSeatNamePopup = (seatId) => {
    this.seatId = seatId;
    this.setState({ popup: { type: 'captureSeatName' } });
  };

  onUpdateSeatName = (seatName) => {
    const { reduxProps: { storeInfo, login, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { id: employeeId } = login?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, } = selectedCheck || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      employeeCard: null,
      checkHeaderId,
      seatId: this.seatId,
      name: seatName,
    };
    this.seatId = null;
    this.getPopup('spinner', constants.updatingSeatName, null);
    API.renameSeat(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateAgeRestrictedItemsForCheck = () => {
    this.setState({
      popup: {
        type: 'login',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_CHECK }
      }
    });
  };

  invokeAgeRestrictedItemsForCheck = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, orders } = selectedCheck || {};
    const [order0] = orders || [];
    const { disableAgeRestricted } = order0 || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForCheck(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onUpdateAgeRestrictedItemsForSeat = (seatId, disableAgeRestricted) => {
    this.ageRestrictedItemsForSeat = { seatId, disableAgeRestricted };
    this.setState({
      popup: {
        type: 'login',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_SEAT }
      }
    });
  };

  invokeAgeRestrictedItemsForSeat = (employeeId) => {
    //if disableAgeRestricted is true - send false to endpoint
    //if disableAgeRestricted is false - send true to endpoint
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId } = selectedCheck || {};
    const { seatId, disableAgeRestricted } = this.ageRestrictedItemsForSeat || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      seatId: seatId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForSeat(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  sendPendingItems = () => {
    const { pendingItems, selectedCheck } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo, login, deviceApi, deviceApiData } = reduxProps;
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { id: employeeId } = login?.data || {};
    if (pendingItems) {
      const checkValues = Object.values(pendingItems);
      if (checkValues && checkValues.length > 0) {
        checkValues.forEach(eachSeat => {
          if (eachSeat && eachSeat.length > 0) {
            this.getPopup("spinner", constants.sendPendingItems, null);
            let allItems = [];
            eachSeat.forEach(eachItem => {
              allItems.push({
                checkOrderItemId: eachItem.id,
                orderSendMode: eachItem.orderSendMode,
              });
            });

            const request = {
              storeId: storeInfo.data.id,
              employeeId: employeeId || null,
              deviceId: deviceId,
              checkHeaderId: selectedCheck?.checkHeaderId || selectedCheck?.id,
              employeeCard: null,
              items: allItems,
            }
            API.firePendingItems(request)
              .then((res) => {
                this.closePopup();
                FireboardUtils.addNetworkLogs(res);
              })
              .catch((error) => this.handleErrorPopup(error));
          }
        })
      }
    }
  };

  onLogin = (loginId, indentifier) => {
    const { reduxProps: { deviceApi, deviceApiData } } = this.props;
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const payload = {
      deviceId: deviceId,
      appVersion: version,
      employeeCode: loginId,
      employeeCard: null,
      jobId: null,
      manager: false,
    };
    this.getPopup('spinner', constants.loginLoadingHeading, null);
    API.login(payload, true)
      .then(response => {
        const { id: employeeId } = response.data;
        if (indentifier === checkEnum.ID_CHECK) {
          this.onMarkAsAgeVerified(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_CHECK) {
          this.invokeAgeRestrictedItemsForCheck(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_SEAT) {
          this.invokeAgeRestrictedItemsForSeat(employeeId);
        } else {
          this.setState({ popup: undefined });
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsAgeVerified = () => {
    this.setState({ popup: { type: 'login', metaData: { indentifier: checkEnum.ID_CHECK } } })
  };

  onMarkAsAgeVerified = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, orders } = selectedCheck || {};
    const [order0] = orders || [];
    const { ageVerificationStatus } = order0 || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      checkHeaderId,
      confirmIdCheck: ageVerificationStatus === 5 ? false : true,
    };
    const spinnerMsg = ageVerificationStatus === 5 ? constants.clearingIdCheck : constants.confirmingIdCheck;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageVerification(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshCubby();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  get viewProps() {
    const {
      popup,
      check,
      isCustomSmsType,
      customSmsList,
      selectedCheck,
      twoDimensionSlot,
      isDevEnvironment,
      fromFooter,
      checksForAssignment,
      isPickedUpUndoEnabled,
      sortByName,
      ascending,
      showCheckDetails,
      items,
      pendingItems,
      showClosedChecks,
      showSearch,
    } = this.state;
    const { reduxProps: { storeInfo, currencyInfo, deviceApi, deviceApiData } } = this.props || {};
    const { iso2 } = currencyInfo || {};
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    const checkSortFunc = this.getCheckSortFunc();
    const checkList = this.getCheckList();

    return {
      popup,
      check,
      parentRoute: this.parentRoute,
      checkList,
      iso2,
      currency: this.currency,
      isCustomSmsType,
      customSmsList,
      storeInfo: storeInfo.data,
      selectedCheck,
      twoDimensionSlot,
      isDevEnvironment,
      notifyOrderPrepared: this.notifyOrderPrepared,
      notifyOrderReady: this.notifyOrderReady,
      fromFooter,
      deviceGroup,
      checksForAssignment,
      isPickedUpUndoEnabled,
      sortByName,
      ascending,
      showCheckDetails,
      items,
      pendingItems,
      showClosedChecks,
      showSearch,
      enableAgeRestrictedOrderingForCheck: this.enableAgeRestrictedOrderingForCheck,
      enableAgeRestrictedOrderingForSeat: this.enableAgeRestrictedOrderingForSeat,
      enableAgeVerification: this.enableAgeVerification,
      checkSortFunc: checkSortFunc,
      closePopup: this.closePopup,
      showPopup: this.showPopup,
      goBack: this.goBack,
      onSlotActionButtonPress: this.onSlotActionButtonPress,
      onChangeSmsType: this.onChangeSmsType,
      onHandleSend: this.onHandleSend,
      onSlotAssign: this.onSlotAssign,
      onMoveSlotOrder: this.onMoveSlotOrder,
      updateOrderStatus: this.updateOrderStatus,
      onHandleTextToPay: this.onHandleTextToPay,
      textToCheckIn: this.textToCheckIn,
      notifyOrderStatus: this.notifyOrderStatus,
      onResyncCheck: this.onResyncCheck,
      joinCheck: this.joinCheck,
      markItemAsPaid: this.markItemAsPaid,
      invokeTextToPay: this.invokeTextToPay,
      invokeCheckIn: this.invokeCheckIn,
      onQRGenerate: this.generateQR,
      openPaymentHistory: this.openPaymentHistory,
      rePostPayment: this.rePostPayment,
      onPressRedeemVoucher: this.onPressRedeemVoucher,
      onRedeemVoucher: this.onRedeemVoucher,
      onRequestRefreshGuestGPS: this.onRequestRefreshGuestGPS,
      onSelectCheckForAssignment: this.onSelectCheckForAssignment,
      onOrderDelivered: this.onOrderDelivered,
      onUpdateGuestInformation: this.onUpdateGuestInformation,
      markAsSeeCounter: this.markAsSeeCounter,
      undoPickedUp: this.undoPickedUp,
      onToggleSwitch: this.onToggleSwitch,
      onShowCheckDetails: this.onShowCheckDetails,
      onCloseCheckDetails: this.onCloseCheckDetails,
      showMemberDetailPopup: this.showMemberDetailPopup,
      onClickSms: this.onClickSms,
      onPrintPress: this.onPrintPress,
      onToggleSearchInput: this.onToggleSearchInput,
      onSearch: this.onSearch,
      openCaptureSeatNamePopup: this.openCaptureSeatNamePopup,
      onUpdateSeatName: this.onUpdateSeatName,
      onUpdateAgeRestrictedItemsForCheck: this.onUpdateAgeRestrictedItemsForCheck,
      onUpdateAgeRestrictedItemsForSeat: this.onUpdateAgeRestrictedItemsForSeat,
      sendPendingItems: this.sendPendingItems,
      markAsAgeVerified: this.markAsAgeVerified,
      onLogin: this.onLogin,
    };
  };

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchRetryPOS: (payload) => {
    dispatch(retryPOSPayment(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(compose(withSocketContext, withCubbyContext)(StoreCubby));
